import _ from "lodash";
import { Platform } from "react-native";
import { SupportedLanguage } from "./SupportedLanguage";

/**
 * Get the base URL with the current language. For example if the current language
 * is `hr`, the base URL will be `https://example.com/hr`. For default language
 * the base URL will be `https://example.com/`
 *
 * @returns {string} The base URL with the current language.
 */
export function getBaseURLForLanguage(omitDomain = false) {
  if (Platform.OS !== "web") return "/";

  const maybeLanguage = window.location.pathname.split("/")[1];

  const supportedLanguageList = _.without(
    Object.values(SupportedLanguage),
    intl.defaultLocale,
  );
  const language = supportedLanguageList.includes(
    maybeLanguage as SupportedLanguage,
  )
    ? maybeLanguage
    : intl.defaultLocale;

  if (language === intl.defaultLocale) {
    if (omitDomain) {
      return "/";
    } else {
      // return SITE.origin + "/";
      return window.location.origin + "/";
    }
  }

  if (omitDomain) {
    return "/" + language;
  }

  // return SITE.origin + "/" + language;
  return window.location.origin + "/" + language;
}
